export default "__VITE_ASSET__DtIGgtLH__"